import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class WarehouseService {
  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) {

  }

  getImplants(warehouseId: string, type: string, page: string = "", search: string = "", expiry: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/implants?type=${type}&page=${page}&expiry=${expiry}&search=${search}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getWarehouseDetails(warehouseId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getImplantDetails(warehouseId: string, implantId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/implants/${implantId}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getProductDetails(productId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/products/${productId}`, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  addProducts(warehouseId: string, data): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.DASBOARD_URL}/warehouses/${warehouseId}/implants`, data,{
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  searchProducts(text: string): Observable<any> {

    return this.http.get(`${this.DASBOARD_URL}/products/search?text=${text}`)
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  // transit stocks
  getTransitStocks(warehouseId: string, page: string = "", search: string = "", shippedAt: string = "", deliveredAt: string = "", status: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/transits/summary?page=${page}&search=${search}&shipped_at=${shippedAt}&delivered_at=${deliveredAt}&status=${status}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getTransitSummaryDetails(warehouseId: string, shipmentId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/transits/summary/${shipmentId}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getTransitSummaryProducts(warehouseId: string, shipmentId: string, page: string = "", search: string = "", expiry: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/transits/summary/${shipmentId}/products?page=${page}&search=${search}&expiry=${expiry}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getTransitSummaryProductsChildren(warehouseId: string, shipmentId: string, productId: string, expiry: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/warehouses/${warehouseId}/transits/summary/${shipmentId}/products/${productId}?expiry=${expiry}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  updatePrintLabelStatus(data: any): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.DASBOARD_URL}/bulk-stocks/print_label_status`, data, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res;
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  connectToPrinter(): Observable<any> {
    return this.http.get(BASE_URL.PRINTER_APP_URL + `print/inspect`)
      /* .pipe(
        map((res: any) => {
          return res;
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      ) */;
  }
  printerTags(data): Observable<any> {
    return this.http.post(BASE_URL.PRINTER_APP_URL + `print/tags`, data)
      /* .pipe(
        map((res: any) => {
          return res;
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      ) */;
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422 || error.status === 405){
      this.spinnerService.hide();
      return throwError(()=> error);
    }
    else{
      console.error('server error:', error);
    }

  }
}
